/**
 * Created by tlester3 on 4/17/16.
 */
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('authentication', authentication);

    authentication.$inject = ['$http', '$cookies', '$q', '$log', '$window', '$location', 'config', '_', 'moment'];

    function authentication($http, $cookies, $q, $log, $window, $location, config, _, moment) {
        var host = $window.location.protocol + "//" + $window.location.host;

        return {
            isLoggedIn: isLoggedIn,

            register: register,
            logIn: logIn,
            getLastLoginDate: getLastLoginDate,
            logOut: logOut,
            logOutOfAppOnly: logOutOfAppOnly,
            logOutCasOnly: logOutCasOnly,
            keepAlive: keepAlive,
            isAosProfileValid: isAosProfileValid,
            isCommunityArchived: isCommunityArchived,
            getLoginStats: getLoginStats,

            getProxyTicket: getProxyTicket,

            getArmyComponents: getArmyComponents,
            getBranchOfServices: getBranchOfServices,
            getCivilianPayGrades: getCivilianPayGrades,
            getDispositions: getDispositions,
            getPayGrades: getPayGrades,

            setUserProfile: setUserProfile,
            getUserProfile: getUserProfile,
            getCommunities: getCommunities,

            changeLoginEmail: changeLoginEmail,
            changeLoginPassword: changeLoginPassword,

            getEmail: getEmail,
            getCacInfo: getCacInfo,
            getCasInfoForUser: getCasInfoForUser,
            getCasInfoForUsers: getCasInfoForUsers,
            getCacInfoFromCard: getCacInfoFromCard,
            resetUser: resetUser,
            resetPassword: resetPassword,
            enableUser: enableUser,
            disableUser: disableUser,
            refreshUser: refreshUser,
            setAdminStatusAFWP: setAdminStatusAFWP,
            setAdminStatus: setAdminStatus,
            verifyAccount: verifyAccount,
            sendVerificationEmail: sendVerificationEmail,

            getCommunitiesWithArchives: getCommunitiesWithArchives,
            addCommunityInTree: addCommunityInTree,
            changeCommunityInTree: changeCommunityInTree,
            inactivateCommunity: inactivateCommunity,

            checkCoreApiHealth: checkCoreApiHealth,
            checkSsoHealth: checkSsoHealth
        };

        function saveEmail(email, expiration) {
            $cookies.put('cas-email', email, {
                expires: expiration
            });
        }

        function saveToken(token, expiration) {
            $cookies.put('cas-ticket', token, {
                expires: expiration
            });
        }

        function saveCacInfo(registered, inUse, expiration) {
            $cookies.put('cac-registered', registered, {
                expires: expiration
            });
            $cookies.put('cac-in-use', inUse, {
                expires: expiration
            });
        }

        function getToken() {
            return $cookies.get('cas-ticket');
        }

        function getEmail() {
            return $cookies.get('cas-email');
        }

        function getCacInfo() {
            return {
                registered: $cookies.get('cac-registered'),
                inUse: $cookies.get('cac-in-use')
            };
        }

        function destroyTokens() {
            $cookies.remove('cas-ticket');
            $cookies.remove('cas-email');
            $cookies.remove('cac-registered');
            $cookies.remove('cac-in-use');
        }

        function isLoggedIn() {
            return !!getToken();
        }

        function register(params) {
            var data = {
                email: params.email,
                password: params.password
            };
            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/login/sign_up', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        // NOTE: CHANGED FOR CORE
        function logIn(ticket, service) {
            if (service === null || service === undefined) {
                service = encodeURIComponent(host + ($location.path() === '/' ? '' : $location.path()));
            }

            var data = {
                ticket: ticket,
                service: service
            };

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/login/sign_in_with_ticket', data);
            }).then(httpSuccess).then(onSuccess).catch(httpFailure);

            function onSuccess(response) {
                var expiration = moment().add(response.expires_in, 'minutes').toDate();
                saveToken(response.access_token, expiration);
                saveEmail(response.email, expiration);
                saveCacInfo(response.cac_registered, response.cac_in_use, expiration);

                return getCasInfoForUser(response.email)
                    .then(function (result) {
                        response.isAdmin = result.user.admin;
                        return response;
                    })
                    .catch(function (error) {
                        return httpFailure(error);
                    });
            }
        }

        function getCacInfoFromCard() {
            return config.get().then(function (configData) {
                console.log("🔍 CAC Info config:", configData.cacInfo);

                if (!configData.cacInfo || !configData.cacInfo.enable) {
                    console.log("⚠️ CAC Info disabled or missing in config");
                    return null;
                }

                console.log("📡 Calling CAC Info endpoint:", configData.cacInfo.path);

                return $http.get(configData.cacInfo.path, {timeout: 100000,
                    withCredentials: true})
                    .then(httpSuccess)
                    .catch((err) => {
                        console.error("❌ CAC Info request failed:", err);
                        if (err && err.data) {
                            console.error("🔎 Error response data:", err.data);
                        }
                        if (err && err.status) {
                            console.error("📛 HTTP status:", err.status);
                        }
                        return null;
                    });

            });
        }



        function getCasInfoForUsers(searchString) {
            var data = {
                searchString: searchString
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/lookup_users_cas", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCasInfoForUser(email) {
            var data = {
                email: email
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/user_info_cas", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getLoginStats(startDate,endDate) {
            var data = {
                startDate: startDate,
                endDate: endDate
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/login_stats", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getLastLoginDate() {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/get_last_login', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOutOfAppOnly () {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOut() {
            var casServer = "";
            return config.get().then(function (configData) {
                casServer = configData.casServer; // Store value while config data is in-scope
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                // Destroying tokens should come after logging out via Core API
                destroyTokens();
                // See loggedOut.routes.js
                window.location.href = casServer + 'logout?service=' +
                    encodeURI($window.location.protocol + "//" + $window.location.host + "/logged-out");
            }).catch(httpFailure).catch(function (error) {
                destroyTokens();
                return $q.reject(error);
            });
        }

        // Used for email and password changes where the API logs the user out of Core, it seems,
        // and the "log in first" error throws things off.
        function logOutCasOnly() {
            destroyTokens();
            return config.get().then(function (configData) {
                // See loggedOut.routes.js
                window.location.href = configData.casServer + 'logout?service=' +
                    encodeURI($window.location.protocol + "//" + $window.location.host + "/logged-out");
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function keepAlive() {
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/keep_alive', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                saveToken(getToken(), new Date(response.expiresOnDate));
                return response;
            }).catch(httpFailure).catch(function (error) {
                destroyTokens();
                return $q.reject(error);
            });
        }

        function getProxyTicket() {
            var data = {};
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/proxyTicket', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function verifyAccount (emailAddress, token) {
            var data = {
                email: emailAddress,
                token: token
            };
            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/login/verify_cas_account', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function sendVerificationEmail (emailAddress){
            var data = {
                email: emailAddress
            };
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/login/get_cas_verification_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function resetUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/reset_account', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function resetPassword(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/reset_with_temp_password', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function enableUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/enable', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function disableUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/disable', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function refreshUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/refresh', data);
            }).then(httpSuccess).catch(httpFailure);
        }


        function setAdminStatusAFWP(emailAddress, isRemovingAdmin) {
            var data = {
                userEmail: emailAddress,
                isRemovingAdmin: isRemovingAdmin
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_admin_status_AFWP', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setAdminStatus(emailAddress, isRemovingAdmin, proxyTicket) {

            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket,
                isRemovingAdmin: isRemovingAdmin
            };

            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_admin_status', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function isAosProfileValid(aosProfile) {
            if (!isLoggedIn()) return false;

            var isProfileValid = aosProfile.firstName &&
                aosProfile.lastName &&
                aosProfile.dateOfBirth &&
                aosProfile.communityAffiliationId &&
                aosProfile.branchOfService &&
                aosProfile.armyComponent &&
                aosProfile.dispositions.length > 0;

            //check dispositions
            if (_.indexOf(aosProfile.dispositions, 'Service Member') >= 0) isProfileValid = isProfileValid && aosProfile.payGrade;
            if (_.indexOf(aosProfile.dispositions, 'Family Member') >= 0) isProfileValid = isProfileValid && aosProfile.sponsorPayGrade;
            if (_.indexOf(aosProfile.dispositions, 'DoD Civilian') >= 0) isProfileValid = isProfileValid && aosProfile.civilianPayGrade;

            return !!isProfileValid;

        }

        function isCommunityArchived(communityAffiliationId) {
            return getCommunityInfo(communityAffiliationId)
                .then(function (comm) {
                    return comm.communityAffiliations.isArchived;
                });
        }

        function getArmyComponents() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/armyComponents");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getBranchOfServices() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/branchOfService");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCivilianPayGrades() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/civilianPayGrades");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getDispositions() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/dispositions");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getPayGrades() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/payGrades");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getUserProfile(email) {
            var data = {
                authorization: getToken()
            };

            if(angular.isDefined(email) && email !== null){
                data.email = email;
            }

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/get_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setUserProfile(profile) {
            var profileCopy = angular.copy(profile, {});
            var data = {
                authorization: getToken(),
                aosUser: profileCopy
            };
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunities(params) {
            var data = angular.copy(params);
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/uidata/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunityInfo(communityAffiliationId) {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/uidata/communities/' + communityAffiliationId);
            }).then(httpSuccess).catch(httpFailure);
        }

        function changeLoginEmail(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/change_login_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function changeLoginPassword(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/change_login_password', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunitiesWithArchives() {
            var data = {withArchives: 1};
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/ui_data/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function addCommunityInTree(params) {
            var data = {
                isArchived: params.isArchived,
                name: params.name,
                isLeaf: params.isLeaf,
                communityParentId: params.communityParentId
            };

            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/authorized_api/ui_data/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function inactivateCommunity(params) {
            var data = {
                communityAffiliationId: params.communityAffiliationId
            };
            data.authorization = getToken();

            // TODO: Move this VMIS-specific functionality elsewhere
            /*
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/inactivate_orgs_in_community', data);
            }).then(httpSuccess).catch(httpFailure);
            */
        }

        function changeCommunityInTree(params) {
            var data = {
                communityAffiliationId: params.id,
                isArchived: params.isArchived,
                name: params.name,
                isLeaf: params.isLeaf,
                communityParentId: params.communityParentId
            };
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/ui_data/communities/change', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        /**
         * Gets information from Core API health check.
         * @param params Any of acceptable parameters to check aspects of API health (unacceptable ones are ignored) (optional)
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkCoreApiHealth(params) {
            return config.get().then(function (configData) {
                return checkHealth(configData.coreServer, params);
            });
        }

        function checkHealth(api, params) {
            if (params !== undefined && !Array.isArray(params)) {
                console.warn("Attempted to pass non-array into API health check!");
                return;
            }
            var paramsStr = "";

            // "params" is optional
            if (params) {
                paramsStr += "?test=";
                params.forEach(function (param) {
                    paramsStr += param.toString() + ",";
                });
            }

            return $http.get(api + '/check_health' + paramsStr).then(httpSuccess).catch(httpFailure);
        }

        /**
         * Gets version information from SSO (CAS) endpoint.
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkSsoHealth() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/login/getCASVersion').then(httpSuccess).catch(httpFailure);
            });
        }

        function httpSuccess(response) {
            if (response.status === 200) {
                if (response.data.success === true) {
                    return response.data;
                }
            }
            return $q.reject(response);
        }

        function httpFailure(error) {
            if (error.status === 200) {
                $log.error(error.config.method, error.config.url, error.data.error);
                return $q.reject(error.data.error);
            }
            var errorText = 'Error: ' + error.status + ', ' + error.statusText;
            $log.error(error.config.method, error.config.url, errorText);
            return $q.reject(errorText);
        }
    }
})();
